/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} In_ProgressInputs */

const en_in_progress = /** @type {(inputs: In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Progress`)
};

const fr_in_progress = /** @type {(inputs: In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

const de_in_progress = /** @type {(inputs: In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Gange`)
};

const it_in_progress = /** @type {(inputs: In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In corso`)
};

const ru_in_progress = /** @type {(inputs: In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В ходе выполнения`)
};

const es_in_progress = /** @type {(inputs: In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En curso`)
};

const zh_cn2_in_progress = /** @type {(inputs: In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进行中`)
};

const ja_in_progress = /** @type {(inputs: In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進行中`)
};

const hi_in_progress = /** @type {(inputs: In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रगति पर है`)
};

const pt_pt2_in_progress = /** @type {(inputs: In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em andamento`)
};

/**
* | output |
* | --- |
* | "In Progress" |
*
* @param {In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const in_progress = /** @type {((inputs?: In_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<In_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_in_progress(inputs)
	if (locale === "de") return de_in_progress(inputs)
	if (locale === "it") return it_in_progress(inputs)
	if (locale === "ru") return ru_in_progress(inputs)
	if (locale === "es") return es_in_progress(inputs)
	if (locale === "zh-CN") return zh_cn2_in_progress(inputs)
	if (locale === "ja") return ja_in_progress(inputs)
	if (locale === "hi") return hi_in_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_in_progress(inputs)
	return en_in_progress(inputs)
});